import ALBUM_90_DEFAULT from '../../static/images/empty_art/album_90.png';
import ALBUM_130_DEFAULT from '../../static/images/empty_art/album_130.png';
import ALBUM_500_DEFAULT from '../../static/images/empty_art/album_500.png';
import ALBUM_600_DEFAULT from '../../static/images/empty_art/album_600.png';
import ALBUM_640_DEFAULT from '../../static/images/empty_art/album_640.png';
import ALBUM_1080_DEFAULT from '../../static/images/empty_art/album_1080.png';
import ARTIST_90_DEFAULT from '../../static/images/empty_art/artist_90.png';
import ARTIST_130_DEFAULT from '../../static/images/empty_art/artist_130.png';
import ARTIST_500_DEFAULT from '../../static/images/empty_art/artist_500.png';
import ARTIST_600_DEFAULT from '../../static/images/empty_art/artist_600.png';
import ARTIST_640_DEFAULT from '../../static/images/empty_art/artist_640.png';
import ARTIST_1080_DEFAULT from '../../static/images/empty_art/artist_1080.png';
import PLAYLIST_90_DEFAULT from '../../static/images/empty_art/playlist_90.png';
import PLAYLIST_130_DEFAULT from '../../static/images/empty_art/playlist_130.png';
import PLAYLIST_500_DEFAULT from '../../static/images/empty_art/playlist_500.png';
import PLAYLIST_600_DEFAULT from '../../static/images/empty_art/playlist_600.png';
import PLAYLIST_640_DEFAULT from '../../static/images/empty_art/playlist_640.png';
import PLAYLIST_1080_DEFAULT from '../../static/images/empty_art/playlist_1080.png';
import PODCAST_90_DEFAULT from '../../static/images/empty_art/podcast_90.png';
import PODCAST_130_DEFAULT from '../../static/images/empty_art/podcast_130.png';
import PODCAST_500_DEFAULT from '../../static/images/empty_art/podcast_500.png';
import PODCAST_600_DEFAULT from '../../static/images/empty_art/podcast_600.png';
import PODCAST_640_DEFAULT from '../../static/images/empty_art/podcast_640.png';
import PODCAST_1080_DEFAULT from '../../static/images/empty_art/podcast_1080.png';

export const DefaultArt = {
  album: {
    90: ALBUM_90_DEFAULT,
    130: ALBUM_130_DEFAULT,
    500: ALBUM_500_DEFAULT,
    600: ALBUM_600_DEFAULT,
    640: ALBUM_640_DEFAULT,
    1080: ALBUM_1080_DEFAULT,
  },
  artist: {
    90: ARTIST_90_DEFAULT,
    130: ARTIST_130_DEFAULT,
    500: ARTIST_500_DEFAULT,
    600: ARTIST_600_DEFAULT,
    640: ARTIST_640_DEFAULT,
    1080: ARTIST_1080_DEFAULT,
  },
  playlist: {
    90: PLAYLIST_90_DEFAULT,
    130: PLAYLIST_130_DEFAULT,
    500: PLAYLIST_500_DEFAULT,
    600: PLAYLIST_600_DEFAULT,
    640: PLAYLIST_640_DEFAULT,
    1080: PLAYLIST_1080_DEFAULT,
  },
  podcast: {
    90: PODCAST_90_DEFAULT,
    130: PODCAST_130_DEFAULT,
    500: PODCAST_500_DEFAULT,
    600: PODCAST_600_DEFAULT,
    640: PODCAST_640_DEFAULT,
    1080: PODCAST_1080_DEFAULT,
  },
} as const;

export const DefaultArtSizes = Object.freeze([90, 130, 500, 600, 640, 1080] as const);
